import { useAtomValue } from 'jotai';

import zipCodeFromUserAtom from './zipCodeFromUserAtom';

const DEFAULT_VALUE = '';

// The new Consumer app can read the value immediately (it has no SSR cookie
// limitation), so we always return the value.
const useZipCodeFromUser = () => {
  const zipCodeFromUser = useAtomValue(zipCodeFromUserAtom);

  return zipCodeFromUser ?? DEFAULT_VALUE;
};

export default useZipCodeFromUser;
